import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Nav, Tab } from 'react-bootstrap';
import TrendsManagement from '../../components/Admin/TrendsManagement';
import RecordAnalysisManagement from '../../components/Admin/RecordAnalysisManagement';

export default function RecordAnalysisPage() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('trends');

  return (
    <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
      <Nav variant="tabs" className="mb-3">
        <Nav.Item>
          <Nav.Link eventKey="trends">
            {t('admin.trendsManagement.tabTitle')}
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="recordAnalysis">
            {t('admin.trendsManagement.recordAnalysisTab')}
          </Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="trends">
          <TrendsManagement />
        </Tab.Pane>
        <Tab.Pane eventKey="recordAnalysis" mountOnEnter>
          <RecordAnalysisManagement />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  );
}
